import useTableRequest from "../../hooks/useTableRequest";
import { useEffect, useState, useMemo } from "react";
import Table from "../../components/common/table/Table";
import Title from "../../components/common/title/Title";
import { productStocksListColumns } from "../../constant/tables-columns/tablesColums";
import ExportExcel from "../../components/common/export-exel/ExportExel";
import { digitsThree } from "../../utils/price";

export default function ProductStockList() {
  const tableRequest = useTableRequest({ initialLoading: true });
  const [productData, setProductData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [inventoryStatusFilter, setInventoryStatusFilter] = useState("all");
  const [sortOrder, setSortOrder] = useState("none");

  const transformData = (products) => {
    return (products || []).filter((item) => !item.hasVar).map((item) => ({
      ...item,
      status: item.status === "active" ? "فعال" : "غیر فعال",
      inventoryStatus:
        item.inventoryStatus === "available" ? "موجود" : "ناموجود",
      buyPriceDisplay: item.buyPrice == null ? "-" : digitsThree(item.buyPrice),
      basePriceDisplay: item.basePrice == null ? "-" : digitsThree(item.basePrice),
    }));
  };

  const getProduct = async () => {
    const path = "admin/products/withSeparationVar";
    return tableRequest.load({ path }, (response) => {
      const convertedData = transformData(response?.data?.result);
      setProductData(convertedData);
    });
  };

  useEffect(() => {
    getProduct();
  }, []);

  const filteredAndSortedData = useMemo(() => {
    let data = [...productData];

    if (searchText) {
      data = data.filter((item) => item.name?.toLocaleLowerCase().includes(searchText.toLocaleLowerCase()));
    }

    if (statusFilter !== "all") {
      data = data.filter((item) => item.status === statusFilter);
    }

    if (inventoryStatusFilter !== "all") {
      data = data.filter(
        (item) => item.inventoryStatus === inventoryStatusFilter
      );
    }

    if (sortOrder === "asc") {
      data.sort((a, b) => a.stock - b.stock);
    } else if (sortOrder === "desc") {
      data.sort((a, b) => b.stock - a.stock);
    }

    return data;
  }, [productData, searchText, statusFilter, inventoryStatusFilter, sortOrder]);

  const exportRows = filteredAndSortedData.map((item) => ({
    "نام محصول / ورژن": item.name,
    "وضعیت نمایش در سایت": item.status,
    "وضعیت موجودی": item.inventoryStatus,
    "موجودی": item.stock,
    "قیمت خرید (تومان)": item.buyPrice ?? "",
    "قیمت فروش (تومان)": item.basePrice ?? "",
    "شناسه": item.sku,
  }));

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6 space-y-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <Title title={"موجودی محصولات"} />
        <ExportExcel disabled={tableRequest.status !== "success"} jsonData={exportRows} />
      </div>

      <div className="flex flex-col md:flex-row gap-4 flex-wrap">
        <input
          type="text"
          placeholder="جستجو نام محصول..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          className="border px-3 py-2 rounded-md w-full md:w-1/3"
        />

        <select
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
          className="border px-3 py-2 rounded-md w-full md:w-1/4"
        >
          <option value="all">همه وضعیت‌های نمایش</option>
          <option value="فعال">فقط فعال</option>
          <option value="غیر فعال">فقط غیر فعال</option>
        </select>

        <select
          value={inventoryStatusFilter}
          onChange={(e) => setInventoryStatusFilter(e.target.value)}
          className="border px-3 py-2 rounded-md w-full md:w-1/4"
        >
          <option value="all">بدون فیلتر موجودی</option>
          <option value="موجود">فقط موجود</option>
          <option value="ناموجود">فقط ناموجود</option>
        </select>

        <select
          value={sortOrder}
          onChange={(e) => setSortOrder(e.target.value)}
          className="border px-3 py-2 rounded-md w-full md:w-1/4"
        >
          <option value="none">بدون مرتب‌سازی موجودی</option>
          <option value="asc">موجودی کم به زیاد</option>
          <option value="desc">موجودی زیاد به کم</option>
        </select>
      </div>

      <Table loading={tableRequest.loading} error={tableRequest.error} idle={tableRequest.status === "idle"} onRetry={tableRequest.retry} columns={productStocksListColumns} rows={filteredAndSortedData} />
    </div>
  );
}
